
export default {
  props: ["title", "description", "route", "icon", "tag", "soon"],
};
